export default "__VITE_ASSET__7g755FlJ__"